import type { ICellRendererParams } from 'ag-grid-community';
import type { NewsArticle } from '../../schema';

export function TitleCell(p: ICellRendererParams<NewsArticle>) {
  if (!p.data) return null;
  return (
    <span className="text-[15px] font-bold leading-tight text-foreground">
      {p.data.title}
    </span>
  );
}
